import { DisplayData, TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { DeliverableType } from '~common/model/Deliverable';
import MlmJob from '~/tenants/mlm/model/MlmJob';
import MlmVirtualConfig from '~/tenants/mlm/performable/virtual/MlmVirtualConfig';
import { TenantJobInput } from '~/tenants/common/TenantJob';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';

export class MlmVirtualJob extends MlmJob<typeof MlmVirtualConfig> {
  get performable() {
    return MlmVirtualConfig;
  }

  get input(): TenantJobInput | null {
    return {
      performables: [MlmPhotosConfig.id],
      required: this.metadata.photos,
      description: 'Select which photos to use for virtual twilight',
      title: 'Virtual Twilight',
    }
  }

  info(): DisplayData[] {
    const info = super.info();

    info.push({
      name: 'Photos',
      value: this.metadata.photos.toString(),
    });

    return info;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.PHOTO;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MlmVirtualConfig)['schema']> {
    return {
      version: schema_latest_version(MlmVirtualConfig.schema),
      photos: 1,
    };
  }

  get configurable() {
    return true;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    lines.push({
      amount: new Big(this.metadata.photos > 4 ? 20 : 25).times(this.metadata.photos),
      taxable: true,
      description: `Virtual Twilight (${this.metadata.photos} photos)`,
      id: 'photos',
    });

    return lines;
  }
}
